import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { Mode } from '@core/constants';
import { LocalStorageService } from '@core/services/common';

@Injectable({
  providedIn: 'root'
})
export class TvNotFoundRedirectGuard implements CanMatch {
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly router: Router
  ) { }

  canMatch(_route: Route, _segments: UrlSegment[]): boolean | UrlTree {
    const savedMode = this.localStorageService.getItem<string | number>(LOCAL_STORAGE_KEY.mode);
    const isTvRoute = _segments[0]?.path === 'tv';
    const isTvMode = Number(savedMode) === Mode.TV || isTvRoute;

    // Return the TV home route so Angular never activates the wildcard 404 component.
    // This only changes the current SPA route; it does not open another native TV tab.
    return isTvMode ? this.router.parseUrl('/') : true;
  }
}
